import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../style/navi.css';

const Navi = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Zamknij menu po kliknięciu linku
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  // Zamknięcie menu po kliknięciu poza nawigację
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup listenera przy odmontowaniu lub zmianie isOpen
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <nav className="navbar" ref={navRef}>
      <div className="menu-toggle" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        <Link to="/" onClick={handleLinkClick}>Strona główna</Link>
        <Link to="/oferta" onClick={handleLinkClick}>Oferta</Link>
        <Link to="/partners" onClick={handleLinkClick}>Nasi partnerzy</Link>
        <Link to="/kontakt" onClick={handleLinkClick}>Kontakt</Link>
        <Link to="/helpdesk" onClick={handleLinkClick}>Zgłoś problem</Link>
        <Link to="/remote" onClick={handleLinkClick}>Pomoc zdalna</Link>
        <Link to="/login" onClick={handleLinkClick}>Logowanie</Link>
      </div>
    </nav>
  );
};

export default Navi;
